<template>
    <div class="fixed z-50 w-full flex flex-wrap justify-center mt-16" v-show="messages.length">
        <div class="container mx-auto">
            <div class="relative rounded text-white text-sm font-bold px-4 py-3 my-1"
                v-for="msg in messages"
                :key="msg.id"
                :class="getClassForBlock(msg.type)">
                <h6 class="font-bold text-lg">
                    {{ msg.title }}
                </h6>
                <span class="block sm:inline" v-if="typeof msg.content == 'string'">
                    {{ msg.content }}
                </span>
                <ul class="list-disc list-inside" v-if="Array.isArray(msg.content)">
                    <li class="font-normal"
                        v-for="(item, idx) in msg.content"
                        :key="idx">
                        {{ item }}
                    </li>
                </ul>
                <span class="absolute top-0 bottom-0 right-0 px-4 py-3">
                    <svg class="fill-current h-6 w-6"
                         role="button"
                         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                         @click="removeMessage({id:msg.id})">
                         <title>Close</title>
                         <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/>
                    </svg>
                </span>
            </div>
        </div>
    </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import messageType from '../eums/messageType';

export default {

    computed: {

        ...mapState(
            'message',
            {
                messages: state => state.messages
            }
        )

    },

    methods: {

        ...mapActions(
            'message',
            [
                'removeMessage'
            ]
        ),

        getClassForBlock(msgType) {
            return {
                'bg-red-500': msgType == messageType.MSG_TYPE_ERROR,
                'bg-yellow-500': msgType == messageType.MSG_TYPE_WARNING,
                'bg-green-500': msgType == messageType.MSG_TYPE_SUCCESS,
                'bg-blue-500': msgType == messageType.MSG_TYPE_INFO,
            };
        }

    },


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
